import { useStoreLogger } from '@/logger.ts'
import { BatchDetailGetList } from '@/api/Batch'
import type { IBatchGetListResponse } from '@/types/BatchTypes.ts'


export async function BatchGetList(): Promise<IBatchGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('BatchGetList')
  const event = await BatchDetailGetList({
    ResponseFilter: {
      Where: {
        OperatorType: "And",
        Operands: [
          {
            Field: "isPreliminary",
            Value: false,
            FilterType: "Equal",
          },
          {
            Field: "appPeriodName",
            Value: 'MONTHLY',
            FilterType: "Equal",
          },
          {
            Field: "isReadyForViewing",
            Value: true,
            FilterType: "Equal",
          },
          {
            Field: "isScenario",
            Value: false,
            FilterType: "Equal",
          }
        ],
      },
    },
  })
  return event
}
